import { createTheme } from "@mui/material/styles";
import grey from "@mui/material/colors/grey";
import { black, green, white, darkBg as bg } from "../constants/colors";
import {
  darkAutoFillStyles,
  lightAutoFillStyles,
  scrollbarStyles,
  buttonStyles,
} from "./en.expand.theme";

const baseTheme = {
  direction: "ltr",
  shadows: ["none"],
  palette: {
    secondary: {
      dark: grey,
      light: "#f9f3f3",
      main: "#b9b4b4",
    },
    primary: {
      dark: "#0f9117",
      main: green,
      light: "#34C759",
      light: "#34C759",
    },
    error: {
      main: "#B00020",
      main: "#B00020",
    },
    white: {
      main: "#ffffff",
    },
    main: "#ffffff",
  },
  scroll: scrollbarStyles,
  shadow: {
    boxShadow: "0px 4px 8px rgb(0,0,0,.1)",
    boxShadow: "0px 4px 8px rgb(0,0,0,.1)",
  },
  typography: {
    fontFamily: ["SFProText", "Arial", "sans-serif", "Helvetica Neue", "Helvetica"].join(","),
  },
  components: {
    MuiInput: {
      styleOverrides: {
        input: {
          "&::placeholder": {
            color: "#b9b4b4",
            fontSize: "1rem",
            fontFamily: "SFProText-Regular",
          },
        },
      },
    },
  },
};

export const lightTheme = createTheme({
  ...baseTheme,
  scroll: {
    ...scrollbarStyles,
    "&::-webkit-scrollbar-track": {
      ...scrollbarStyles["&::-webkit-scrollbar-track"],
      background: white,
    },
  },
  palette: {
    ...baseTheme.palette,
    mode: "light",
    bg: white,
    boxShadow: "rgba(21,34,50, 0.08)",
    toolbarBg: grey[50],
    toolbarContent: black,
    mainText: black,
    divider: "#0000001A",
    GroupsTableHeaderBgColor: "#F6F6F6",
    sentGreenText: "rgb(210, 249, 220)",
    disableInputFiledSettings: "#f9f3f3",
    loginSignUpSubscriptionBG: "#E5F8E9",
    lightRed: "#FFADA8",
    msgColor: "#EFEFF4",
    switch: {
      circle: white,
      bg: "#52d869",
      track: "#BDBDBD",
    },
    flow: {
      bg: "#F0F0F3",
      primary: green,
      secondary: "#999999",
      nodeBg: "#E0E1E6",
      nodeColor: "#222",
      nodeBorder: "#CDCED6",
      minimapMaskBg: "#f2f2f5",
      controlsBg: "#fefefe",
      controlsBgHover: "#eee",
      controlsColor: "#222",
      controlsBorder: "#ddd",
      subNodeBg: "#F9F9FB",
      subNodeTitleBg: "#EDEDED",
    },
  },
  typography: {
    ...baseTheme.typography,
    color: "#525252",
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: lightAutoFillStyles,
      },
    },
    MuiInput: {
      styleOverrides: {
        root: lightAutoFillStyles,
      },
    },
    MuiButton: {
      styleOverrides: buttonStyles("light"),
    },
  },
});

export const darkTheme = createTheme({
  ...baseTheme,
  scroll: {
    ...scrollbarStyles,
    "&::-webkit-scrollbar-track": {
      ...scrollbarStyles["&::-webkit-scrollbar-track"],
      background: bg,
    },
  },
  palette: {
    ...baseTheme.palette,
    mode: "dark",
    bg: "#131516",
    boxShadow: "rgb(155 154 154)",
    toolbarBg: "rgb(27 27 27)",
    greenText: "#72ff72",
    toolbarContent: white,
    mainText: white,
    loginSignUpSubscriptionBG: "#0C2918",
    msgColor: "#EFEFF4",
    GroupsTableHeaderBgColor: "rgb(48 48 48)",
    sentGreenText: "#0a4825",
    disableInputFiledSettings: "rgb(41, 21, 21)",
    lightRed: "rgb(120 0 0)",
    anchorTagLinks: "#3391ff",
    divider: "#FFFFFF1A",
    switch: {
      circle: "rgb(42 60 45)",
      bg: "rgb(33, 145, 75)",
      track: "#5f5f5f",
    },
    flow: {
      bg: "#111113",
      primary: green,
      nodeBg: "#212225",
      nodeColor: "#f9f9f9",
      nodeBorder: "#363A3F",
      minimapMaskBg: "#343435",
      controlsBg: "#555",
      controlsBgHover: "#676768",
      controlsColor: "#dddddd",
      controlsBorder: "#676768",
      subNodeBg: "#18191B",
      subNodeTitleBg: "#151617",
    },
  },
  typography: {
    ...baseTheme.typography,
    color: white,
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: darkAutoFillStyles,
      },
    },
    MuiInput: {
      styleOverrides: {
        root: darkAutoFillStyles,
      },
    },
    MuiButton: {
      styleOverrides: buttonStyles("dark"),
    },
  },
});

const en = {
  dark: darkTheme,
  light: lightTheme,
};

export default en;
